import DeleteModalComponent from "../../../Common/DeleteModal";
import EditManager from "../vendorRequests/EditVendorRequest";
import LoaderScreen from '../../../Common/loaderScreen'
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";
import PropTypes from 'prop-types';
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import {Table, Column} from "@appkit4/react-components/table";
import "../../../../styles/manager.css";
import React, { useState, useEffect } from "react";
export default function AssessmentPlanRequests(props) {
  const { vendorData, handleDelete, getVRequest } = props;
  const [vendorId, setVendorId] = useState();
  const [vendorRequestData, setVendorRequestData] = useState([])
  const [questionnaireClassification, setQuestionnaireClassification] = useState([])
  const [userId, setUserId] = useState();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [editScreen, setEditScreen] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getTPRequestById } = useHttp();

  const handleCancel = () => {
    setDeleteModalVisible(false);
  };
 

  const getByTPRequestID = async (ID) => {
    setDataLoader(true)
    getTPRequestById(APIService.getTPRequestById(ID), (res) => {
      if (res.CODE) {
        setVendorRequestData(res.MSG)
        res.MSG[0].jsonVendorQuestionnaireMaster.map((item) => {
          if (item.question === "What is the information classification of the data that this Vendor processes?"){
            setQuestionnaireClassification(item)
          }
        })
        setEditScreen(true);
      }
    })
    setDataLoader(false)
  };
  
  function formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }


  useEffect(() => {
    setEditScreen(false);
    setTableData(vendorData);
    setFilter(vendorData);
    let totalPageLength = Math.ceil((vendorData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [vendorData]);

  useEffect(() => {
    const result = tableData?.filter((planList) => {
      return planList?.vendor_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);

  const handelEditScreen = () => {
    setEditScreen(false);
    setTableData(vendorData);
    setFilter(vendorData);
    let totalPageLength = Math.ceil((vendorData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
    getVRequest();
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.vendor_name).charAt(1);
    const secondOrderId = (b.vendor_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.vendor_name).charAt(1);
    const secondOrderId = (b.vendor_name).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
  }

  const renderEndDate = (row) => {
    return formatDate(row?.lastassessmentdate);
  }

  const renderStatus = (row) => {
    let stylesClass;
    switch (row?.statusName) {
      case "Expired":
      stylesClass = "Expired-status";
      break;
      case "Open":
      stylesClass = "Open-status";
      break;
      case "Close":
      stylesClass = "Close-status";
      break;
      default:
      stylesClass = "";
    }
    let className = "bia-status " + stylesClass;
    return <div className={className}>{row?.statusName}</div>
  }

  const renderActionCell = (row) => {
    return (
      <>
      <span className=" Appkit4-icon icon-view-fill pointer action-icon" title="View request" onClick={() => handleViewButton(row)}></span>&nbsp;
      <span className=" Appkit4-icon icon-edit-fill pointer action-icon" title="Edit request" onClick={() => handleEditButton(row)}></span>&nbsp;
      <span className=" Appkit4-icon icon-delete-fill pointer action-icon" title="Delete request" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const handleViewButton = (row) => {
    if (row?.vendorassessmentrequestid) {
      getByTPRequestID(row?.vendorassessmentrequestid)
      setViewOnly(false)
    }
  }

  const handleEditButton = (row) => {
    if (row?.vendorassessmentrequestid) {
      getByTPRequestID(row?.vendorassessmentrequestid)
      setViewOnly(true)
    }
  }

  const handleDeleteButton = (row) => {
    setVendorId(row?.vendorid);
    setUserId(row?.createdby);
  }

  return (
    <div className="App">
      {!editScreen ?
        <div className="col-lg-12 mt-3 pl-1">
          {tableData.length > 0 ? (
            <Input
            type="text"
            title= "Search Third Party Name"
            value={search}
            className="ap-field-wrapper-tableSearch"
            onChange={(e) => setSearch(e)}
          /> 
          ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "" : "biaTableBU"}>
                    <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2} className={filter.length === 0 ? "" : "oneEighty"}>Third Party Name</Column>
                    <Column field="status" sortKey={filter.length > 0 ? "status" : ""}>Status</Column>
                    <Column field="criticality" sortKey={filter.length > 0 ? "criticality" : ""}>Criticality</Column>
                    <Column field="lastassessmentdate" sortKey={filter.length > 0 ? "lastassessmentdate" : ""} renderCell={renderEndDate} className={filter.length === 0 ? "" : "twoHundred"}>Last Assessment Date</Column>
                    <Column field="status" sortKey={filter.length > 0 ? "status" : ""} renderCell={renderStatus} className={filter.length === 0 ? "" : "twoTwenty"}>Last Assessment Status</Column>
                    <Column field="recurrencemonthname" sortKey={filter.length > 0 ? "recurrencemonthname" : ""} className={filter.length === 0 ? "" : "twoHundred"}>Recurrence Month</Column>
                    <Column field="thirdpartycontactname" sortKey={filter.length > 0 ? "thirdpartycontactname" : ""} className={filter.length === 0 ? "" : "twoThirty"}>Third Party Contact Name</Column>
                    <Column field="thirdpartyphonenumber" sortKey={filter.length > 0 ? "thirdpartyphonenumber" : ""} className={filter.length === 0 ? "" : "twoThirty"}>Third Party Contact</Column>
                    <Column field="vendorassessmentrequestid"
                    renderCell={renderActionCell}
                    className={filter.length === 0 ? "" : "oneFifty"}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
          <DeleteModalComponent
            content={"Are you sure you want to delete this third party account?"}
            visible={deleteModalVisible}
            cancel={handleCancel}
            // confirm={() => handleDelete(vendorId, userId)}
          />
        </div>
        :
        dataLoader ? <LoaderScreen /> : (<EditManager sendBack={handelEditScreen} TPRequestData={vendorRequestData} View={viewOnly} questionnaireClassification={questionnaireClassification} />
        )
      }
    </div>
  );
}
AssessmentPlanRequests.propTypes = {
  vendorData:PropTypes.array,
  handleDelete:PropTypes.func,
  getVRequest:PropTypes.func
}
